import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { getFunctions, httpsCallable } from '@angular/fire/functions';
import { map, Observable, take } from 'rxjs';
import { Prayer } from '../models/prayer.model';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root',
})
export class PrayerService {
  http = inject(HttpClient);
  utilsService = inject(UtilsService);

  constructor(private afs: AngularFirestore) {}

  getPrayerById(id: string): Observable<Prayer> {
    const doc = this.afs.collection<Prayer>('prayers').doc(id).get();
    return doc.pipe(
      take(1),
      map((doc) => {
        return { ...doc.data(), id: id } as Prayer;
      })
    );
  }

  async create(prayer: Prayer): Promise<string> {
    // console.log('PrayerService:: create:', JSON.stringify(prayer, null, 2));
    const doc = await this.afs.collection('prayers').add(prayer);
    return doc.id;
  }

  async update(id: string, prayer: Prayer): Promise<void> {
    // console.log(
    //   `PrayerService:: update: ${id}: `,
    //   JSON.stringify(prayer, null, 2)
    // );
    return this.afs.collection<Prayer>('prayers').doc(id).update(prayer);
  }

  async delete(id: string): Promise<void> {
    return this.afs.collection<Prayer>('prayers').doc(id).delete();
  }

  async getPrayerStats(groupId: string): Promise<any> {
    try {
      const functions = getFunctions();
      const callable = httpsCallable(functions, 'prayerCount');
      const result = await callable({
        groupId,
      });
      // console.log(`Response: ${JSON.stringify(result)}`);
      return result.data;
    } catch (error) {
      // console.log(`PrayerService :: getPrayerStats: Error: ${error}`);
      return Promise.reject('Unable to fetch Prayer Statistics');
    }
  }
}
